export default "__VITE_ASSET__bf10731d__"